import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';
import { FtbComponentInput } from '@/types/schema';

import QuestionEditorContainer from '../../components/QuestionEditorContainer';
import RichTextEditor from './Editor';
import { questionEditorStyles } from './styles';

function FTBEditor(props: QuestionEditorProps) {
  const { question, onChange, viewMode } = props;
  const { t } = useTranslation();

  const onChangeFtb = useCallback(
    (content: Array<FtbComponentInput>, questionText: string) => {
      onChange({ ...question, questionText, ftbComponents: { set: content } });
    },
    [onChange, question],
  );

  return (
    <QuestionEditorContainer maxWidth={60} {...props}>
      <Stack className="mt-4 px-16" direction="col">
        <RichTextEditor
          className={questionEditorStyles}
          ftbComponents={question?.ftbComponents?.set || []}
          placeholder={t('QuizCreator:FtbQuestionPlaceholder')}
          variant="heading-m"
          viewMode={viewMode}
          onChangeFtb={onChangeFtb}
        />
      </Stack>
    </QuestionEditorContainer>
  );
}

export default FTBEditor;
